import React from 'react';
import Roles from '../../components/AdminNext/Roles';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Roles & permissions — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Roles />
      </HeadLessLayout>
    )
  };
}

export default action;
